<template>
  <div class="container">
    <online-complaint class="online-com" />
    <material-complaint class="material-com" />
  </div>
</template>

<script>
import OnlineComplaint from "./components/OnlineComplaint";
import MaterialComplaint from "./components/MaterialComplaint";
export default {
  components: {
    MaterialComplaint,
    OnlineComplaint
  }
};
</script>
<style lang="scss" scoped>
.container {
  min-width: 960px;
  width: 80%;
  margin: 0 auto;
  overflow: hidden;
  display: flex;
  justify-content: space-between;
  .online-com {
    margin-right: 35px;
  }
}
</style>
